import { render } from "./RecoverPassword.vue?vue&type=template&id=3f6ed0d0&scoped=true&ts=true"
import script from "./RecoverPassword.vue?vue&type=script&lang=ts"
export * from "./RecoverPassword.vue?vue&type=script&lang=ts"

import "./RecoverPassword.vue?vue&type=style&index=0&id=3f6ed0d0&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6ed0d0"]])

export default __exports__